var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "43px",
    viewBox: "0 0 52 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chest") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homunculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homunculus--Both-Filled",
    transform: "translate(-190.000000, -91.000000)",
    fill: "#D2D9E8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5698894,51.7420815 C18.2058828,51.042079 21.769414,49.9007679 26.2604832,48.3181483 C29.8755365,48.3698564 39.5834112,48.3815244 55.3841075,48.3531524 L66.6149812,52.4722081 C65.4760405,67.6314081 64.7776293,76.5800548 64.5197474,79.3181483 C64.2618656,82.0562418 63.8972955,86.0562418 63.4260371,91.3181483 L18.073542,91.3181483 L17.3477978,84.2292181 L15.5698894,51.7420815 Z",
    id: "Chest"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChest);
export default __webpack_public_path__ + "static/media/Chest.8f40d3ab39edb2f9ceb8072fb6b62e80.svg";
export { ForwardRef as ReactComponent };